export default __webpack_public_path__ + "static/media/indiamap.fb215dea.jpg";